var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('navbar'),_vm._v(" "),_c('v-main',{staticClass:"default-background"},[_c('v-container',{staticClass:"root-container"},[_c('nuxt')],1)],1),_vm._v(" "),_c('discover-search-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }